const DocumentIcon = ({ size = 28 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25 14.5C8.83579 14.5 8.5 14.8358 8.5 15.25C8.5 15.6642 8.83579 16 9.25 16H18.75C19.1642 16 19.5 15.6642 19.5 15.25C19.5 14.8358 19.1642 14.5 18.75 14.5H9.25ZM8.5 18.25C8.5 17.8358 8.83579 17.5 9.25 17.5H18.75C19.1642 17.5 19.5 17.8358 19.5 18.25C19.5 18.6642 19.1642 19 18.75 19H9.25C8.83579 19 8.5 18.6642 8.5 18.25ZM9.25 20.5C8.83579 20.5 8.5 20.8358 8.5 21.25C8.5 21.6642 8.83579 22 9.25 22H18.75C19.1642 22 19.5 21.6642 19.5 21.25C19.5 20.8358 19.1642 20.5 18.75 20.5H9.25ZM4 4.4C4 3.07452 5.07452 2 6.4 2H14.5665C15.2031 2 15.8135 2.25286 16.2636 2.70294L23.1945 9.63388C23.7103 10.1496 24 10.8491 24 11.5784V23.6C24 24.9255 22.9255 26 21.6 26H6.4C5.07452 26 4 24.9255 4 23.6V4.4ZM6.4 3.5C5.90294 3.5 5.5 3.90294 5.5 4.4V23.6C5.5 24.0971 5.90294 24.5 6.4 24.5H21.6C22.0971 24.5 22.5 24.0971 22.5 23.6V12H16C14.8954 12 14 11.1046 14 10V3.5H6.4ZM16 10.5H21.9393L15.5 4.06066V10C15.5 10.2761 15.7239 10.5 16 10.5Z"
        fill="#5246EE"
      />
    </svg>
  );
};

export default DocumentIcon;
